/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_IntroInputs */

const en_about_intro = /** @type {(inputs: About_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The repeated questions. The information in three different places. The step that only moves when someone remembers.`)
};

const lv_about_intro = /** @type {(inputs: About_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atkārtoti jautājumi. Informācija trijās dažādās vietās. Darbs, kas virzās uz priekšu tikai tad, kad kāds par to atceras.`)
};

/**
* | output |
* | --- |
* | "The repeated questions. The information in three different places. The step that only moves when someone remembers." |
*
* @param {About_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_intro = /** @type {((inputs?: About_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_intro(inputs)
	return en_about_intro(inputs)
});